var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"appear":"","mode":"out-in","duration":250,"name":"ru:wiggle-fade-squish"},on:{"after-enter":_vm.onAfterEnter}},[_c('div',{staticClass:"ru:snackbar",style:(_vm.styles)},[_c('svg',{staticClass:"ru:snackbar__icon",attrs:{"viewBox":"0 0 24 24"}},[_c('use',_vm._b({},'use',{
          'xlink:href': `${require('~/assets/svg/ru-icons.svg')}#${_vm.type}`,
        },false))]),_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }